<template>
  <div>
    <div style="margin: 30px 0">
      <button type="button" class="btn adp-btn mr-1" @click="createMatrix">
        {{ $t('admin.add_matrix_activity') }}
      </button>
      <button type="button" class="btn adp-btn mr-1" @click="importMatrix()">
        {{ $t('admin.import_matrix') }}
      </button>
      <button type="button" class="btn adp-btn mr-1" @click="exportMatrix()">
        {{ $t('admin.export_matrix') }}
      </button>
    </div>

    <div v-if="loading">{{ $t('voc.loading') }}</div>
    <div class="table-idp-activities__matrix" v-if="!loading">
      <div class="adp-grid-row adp-grid-row__matrix">
        <div class="d-flex flex-column adp-grid-cell__head__matrix">
          <div style="white-space: nowrap;" @click="sortChange('title')">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'title'}">
              {{ $t('voc.table_event_name') }} 
            </span>
            <span class="adp-th adp-th__sort__icon">
              <img :src="getSortingIcon('title')" alt="sort">
            </span>
          </div>
          <input @input="searchActivities" type="text" class="adp-input adp-input__catalog adp-input-search" v-model="filterTitles">
        </div>
        <div class="d-flex flex-column adp-grid-cell__head__matrix">
          <div style="white-space: nowrap;" @click="sortChange('position')">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'position'}">
              {{ $t('voc.table_position') }}
            </span>
            <span class="adp-th adp-th__sort__icon">
              <img :src="getSortingIcon('position')" alt="sort">
            </span>
          </div>
          <my-dropdown :options="positions" :init-selected="filterPositions" :has-select-all="true"
                       v-on:my-change="onDropdownUpdate($event, 'filterPositions', 'positions')" :localize="false">
          </my-dropdown>
        </div>
        <div class="d-flex flex-column adp-grid-cell__head__matrix">
          <div style="white-space: nowrap;" @click="sortChange('company')">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'company'}">
              {{ $t('voc.table_company') }}
            </span>
            <span class="adp-th adp-th__sort__icon">
              <img :src="getSortingIcon('company')" alt="sort">
            </span>
          </div>
          <my-dropdown :options="companies" :init-selected="filterCompanies" :has-select-all="true" :localize="false"
                       v-on:my-change="onDropdownUpdate($event, 'filterCompanies', 'companies')">
          </my-dropdown>
        </div>
        <div class="d-flex flex-column adp-grid-cell__head__matrix">
          <div style="white-space: nowrap;" @click="sortChange('department')">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'department'}">
              {{ $t('admin.department') }}
            </span>
            <span class="adp-th adp-th__sort__icon">
                <img :src="getSortingIcon('department')" alt="sort">
            </span>
          </div>
          <my-dropdown :options="departments" :init-selected="filterDepartments" :has-select-all="true" :localize="false"
                       v-on:my-change="onDropdownUpdate($event, 'filterDepartments', 'departments')">
          </my-dropdown>
        </div>
        <div class="d-flex flex-column adp-grid-cell__head__matrix">
          <div style="white-space: nowrap;" @click="sortChange('division')">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'division'}">
              {{ $t('admin.division') }}
            </span>
            <span class="adp-th adp-th__sort__icon">
              <img :src="getSortingIcon('division')" alt="sort">
            </span>
          </div>
          <my-dropdown :options="divisions" :init-selected="filterDivisions" :has-select-all="true" :localize="false"
                       v-on:my-change="onDropdownUpdate($event, 'filterDivisions', 'divisions')">
          </my-dropdown>
        </div>
        <div class="d-flex flex-column adp-grid-cell__head__matrix">
          <div style="white-space: nowrap;" @click="sortChange('subdivision')">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'subdivision'}">
              {{ $t('admin.subdivision') }}
            </span>
            <span class="adp-th adp-th__sort__icon">
              <img :src="getSortingIcon('subdivision')" alt="sort">
            </span>
          </div>
          <my-dropdown :options="subdivisions" :init-selected="filterSubdivisions" :has-select-all="true" :localize="false"
                       v-on:my-change="onDropdownUpdate($event, 'filterSubdivisions', 'subdivisions')">
          </my-dropdown>
        </div>
        <div class="d-flex flex-column adp-grid-cell__head__matrix">
          <div style="white-space: nowrap;" @click="sortChange('level_05')">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'level_05'}">
              {{ $t('voc.table_level') }} 5
            </span>
            <span class="adp-th adp-th__sort__icon">
              <img :src="getSortingIcon('level_05')" alt="sort">
            </span>
          </div>
          <my-dropdown :options="levels05" :init-selected="filterLevels05" :has-select-all="true" :localize="false"
                       v-on:my-change="onDropdownUpdate($event, 'filterLevels05', 'levels05')">
          </my-dropdown>
        </div>
        <div class="d-flex flex-column adp-grid-cell__head__matrix">
          <div style="white-space: nowrap;" @click="sortChange('periodicity')">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'periodicity'}">
              {{ $t('voc.table_periodicity') }}
            </span>
            <span class="adp-th adp-th__sort__icon">
              <img :src="getSortingIcon('periodicity')" alt="sort">
            </span>
          </div>
          <my-dropdown :options="periodicityOptions" :init-selected="filterPeriodicity" :has-select-all="true"
                       v-on:my-change="onDropdownUpdate($event, 'filterPeriodicity', 'periodicityOptions')" :localize="false">
          </my-dropdown>
        </div>
        <div class="d-flex flex-column adp-grid-cell__head__matrix">
          <div style="white-space: nowrap;" @click="sortChange('status')">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'status'}">
              {{ $t('voc.table_status') }}
            </span>
            <span class="adp-th adp-th__sort__icon">
              <img :src="getSortingIcon('status')" alt="sort">
            </span>
          </div>
          <my-dropdown :options="statuses" :init-selected="filterStatuses" :has-select-all="true"
                       v-on:my-change="onDropdownUpdate($event, 'filterStatuses', 'statuses')" :localize="false">
          </my-dropdown>
        </div>
      </div >

      <template>
        <div class="adp-grid-row adp-grid-row__matrix" v-for="item in items"
             :style="item.status === 'not_active' ? 'color: #909397' : ''">
          <div class="adp-grid-cell adp-grid-cell__matrix">
            {{ item.title || '—' }}
          </div>
          <div class="adp-grid-cell adp-grid-cell__matrix">
            {{ item.position || '—'}}
          </div>
          <div class="adp-grid-cell adp-grid-cell__matrix">
            {{ item.company || '—'}}
          </div>
          <div class="adp-grid-cell adp-grid-cell__matrix">
            {{ item.department || '—'}}
          </div>
          <div class="adp-grid-cell adp-grid-cell__matrix">
            {{ item.division || '—'}}
          </div>
          <div class="adp-grid-cell adp-grid-cell__matrix">
            {{ item.subdivision || '—'}}
          </div>
          <div class="adp-grid-cell adp-grid-cell__matrix">
            {{ item.level_05 || '—'}}
          </div>
          <div class="adp-grid-cell adp-grid-cell__matrix">
            {{ item.periodicity ? $t(`admin.${item.periodicity}`) : '—' }}
          </div>
          <div class="adp-grid-cell adp-grid-cell__matrix position-relative">
            {{ item.status ? $t(`admin.${item.status}`) : '—' }}
            <div class="adp-kebab">
              <img src="/images/vertical_dots.svg" alt="" style="padding: 2px 6px; cursor: pointer;" @click.stop="openCM($event, item)">
            </div>
          </div>
        </div >
      </template>
    </div>

    <!-- Pagination -->
    <div class="adp-pagination mt-4" v-if="!loading">
      <div class="adp-pagination-bnt" v-for="(page, index) in pages" v-if="page.url || page.label === '...'" @click="changePage(page.label)"
           :class="{'adp-pagination-bnt__active': page.active}">
        <span v-if="page.label === 'pagination.previous' && page.url"><</span>
        <span v-else-if="page.label === 'pagination.next' && page.url">></span>
        <span v-else>{{ page.label }}</span>
      </div>
      <div style="width: 190px; margin-left: 30px">
        <v-select style="background-color: white" label="text"
                  :options="itemsPerPage"
                  :clearable="false"
                  v-model="itemsPerPageSelected"
                  @option:selecting="selectItemsPerPage($event)"
        >
        </v-select>
      </div>
    </div>

    <!-- Context Menu -->
    <div class="adp-task--crud-actions" :style="cmStyles" v-if="contextMenu.isVisible" v-click-outside="() => hideCM()" ref="contextMenu">
      <div class="btn adp-btn adp-btn__t-left adp-btn__light" @click="editMatrix">
        {{ $t('catalog.view_edit') }}
      </div>
      <div class="btn adp-btn adp-btn__t-left adp-btn__light"
           @click="openAssignmentsModal">
        {{ $t('catalog.view_assignment') }}
      </div>
      <div class="btn adp-btn adp-btn__t-left adp-btn__light" v-if="contextMenu.item.status === 'not_active'"
           @click="changStatus('active')">
        {{ $t('admin.make_active') }}
      </div>
      <div class="btn adp-btn adp-btn__t-left adp-btn__light" v-if="contextMenu.item.status === 'active'"
           @click="changStatus('not_active')">
        {{ $t('admin.make_not_active') }}
      </div>
      <div class="btn adp-btn adp-btn__t-left adp-btn__light" @click="deleteMatrixItem">
        {{ $t('idp.cm_delete') }}
      </div>
    </div>

    <!-- Modals -->
    <assignments-view-modal :activity-id="contextMenu.item.catalog_activity_id || 0" :activity-name="contextMenu.item.title || ''" />
    <matrix-create-modal @matrix-created="getActivities" />
    <matrix-edit-modal :activity="contextMenu.item" @matrix-edited="getActivities" />
    <reports-modal v-show="isReportsOpened" :is-reports-opened="isReportsOpened" @close-reports-modal="isReportsOpened = false"/>
  </div>
</template>

<script>
import {debounce} from 'lodash';
import MyDropdown from "../MyDropdown";
import api from "../../api";
import AssignmentsViewModal from "../modals/AssignmentsViewModal";
import MatrixCreateModal from "./MatrixCreateModal";
import MatrixEditModal from "./MatrixEditModal";
import ReportsModal from "../modals/ReportsModal.vue";

export default {
  name: "MatrixPage",
  components: {
    MatrixEditModal,
    MatrixCreateModal,
    AssignmentsViewModal,
    MyDropdown,
    ReportsModal
  },
  data: function() {
    return {
      reportsButton: document.getElementById('reports-download'),
      reportsLoadingButton: document.getElementById('reports-download-circle'),
      isReportsOpened: false,

      loading: false,
      activePage: 1,
      itemsPerPageCount: 20,
      itemsPerPage: [
        {number: 20, text: `20 ${this.$t('idp.per_page')}`},
        {number: 50, text: `50 ${this.$t('idp.per_page')}`},
        {number: 100, text:`100 ${this.$t('idp.per_page')}`},
      ],
      pages: [],

      items: [],
      activities: [],

      positions: [],
      companies: [],
      departments: [],
      divisions: [],
      subdivisions: [],
      levels05: [],
      periodicityOptions: [],
      statuses: [],

      sortColumn: '',
      sortDirection: '',
      lastUsedFilterOptions: '',

      filterTitles: '',
      filterPositions: [],
      filterCompanies: [],
      filterDepartments: [],
      filterDivisions: [],
      filterSubdivisions: [],
      filterLevels05: [],
      filterPeriodicity: [],
      filterStatuses: [],

      contextMenu: {
        isVisible: false,
        top: 0,
        left: 0,
        item: {},
      },
    }
  },
  computed: {
    itemsPerPageSelected: {
      get() {
        return this.itemsPerPage.find(item => item.number === this.itemsPerPageCount).text
      },
      set({number}) {
        this.itemsPerPageCount = number;
      }
    },
    cmStyles() {
      return {
        top: `${this.contextMenu.top}px`,
        left: `${this.contextMenu.left}px`,
        right: 'unset',
      };
    },
  },
  methods: {
    async getFilterOptions(filters) {
      const resp = await api.getMatrixActivitiesListFilters(filters);

      if (this.lastUsedFilterOptions !== 'positions' || this.filterPositions.length === 0) {
        this.positions = resp.data.position.map(item => ({id: String(item), code: String(item)}));
      }
      if (this.lastUsedFilterOptions !== 'companies' || this.filterCompanies.length === 0) {
        this.companies = resp.data.company.map(item => ({id: String(item), code: String(item)}));
      }
      if (this.lastUsedFilterOptions !== 'departments' || this.filterDepartments.length === 0) {
        this.departments = resp.data.department.map(item => ({id: String(item), code: String(item)}));
      }
      if (this.lastUsedFilterOptions !== 'divisions' || this.filterDivisions.length === 0) {
        this.divisions = resp.data.division.map(item => ({id: String(item), code: String(item)}));
      }
      if (this.lastUsedFilterOptions !== 'subdivisions' || this.filterSubdivisions.length === 0) {
        this.subdivisions = resp.data.subdivision.map(item => ({id: String(item), code: String(item)}));
      }
      if (this.lastUsedFilterOptions !== 'levels05' || this.filterLevels05.length === 0) {
        this.levels05 = resp.data.level_05.map(item => ({id: String(item), code: String(item)}));
      }
      if (this.lastUsedFilterOptions !== 'periodicityOptions' || this.filterPeriodicity.length === 0) {
        this.periodicityOptions = resp.data.periodicity.map(item => ({id: item, code: this.$t(`admin.${item}`)}));
      }
      if (this.lastUsedFilterOptions !== 'statuses' || this.filterStatuses.length === 0) {
        this.statuses = resp.data.status.map(item => ({id: item, code: this.$t(`admin.${item}`)}));
      }
    },
    async getActivities() {
      this.loading = true;
      const data = {
        page: this.activePage,
        count: this.itemsPerPageCount,
        role: this.selectedRole,
        activity_title: this.filterTitles,
        position: this.filterPositions,
        company: this.filterCompanies,
        department: this.filterDepartments,
        division: this.filterDivisions,
        subdivision: this.filterSubdivisions,
        level05: this.filterLevels05,
        periodicity: this.filterPeriodicity,
        status: this.filterStatuses,
        sort_column: this.sortColumn,
        sort_direction: this.sortDirection,
      };

      await this.getFilterOptions(data);
      const resp = await api.getMatrixActivitiesList(data);
      this.activities = resp.data.data;
      this.pages = resp.data.links;
      await this.filterActivities();
      this.loading = false;
    },
    async filterActivities() {
      let items = this.activities;
      items = await this.searchItems();

      this.items = JSON.parse(JSON.stringify(items));
    },
    async searchItems() {
      let items = [];
      const data = {
        page: this.activePage,
        count: this.itemsPerPageCount,
        role: this.selectedRole,
        activity_title: this.filterTitles,
        position: this.filterPositions,
        company: this.filterCompanies,
        department: this.filterDepartments,
        division: this.filterDivisions,
        subdivision: this.filterSubdivisions,
        level05: this.filterLevels05,
        periodicity: this.filterPeriodicity,
        status: this.filterStatuses,
        sort_column: this.sortColumn,
        sort_direction: this.sortDirection,
      };

      await this.getFilterOptions(data);
      let resp = await api.getMatrixActivitiesList(data);
      items = resp.data.data;
      this.pages = resp.data.links;

      return items;
    },
    openCM(event, item) {
      this.contextMenu.top = event.pageY;
      this.contextMenu.left = event.pageX - 231;
      this.contextMenu.item = item;
      this.contextMenu.isVisible = true;
    },
    async selectItemsPerPage(event) {
      this.loading = true;
      try {
        event.number > 20 ? this.activePage = 1 : this.activePage
        const data = {
          page: this.activePage,
          count: event.number,
          role: this.selectedRole,
          activity_title: this.filterTitles,
          position: this.filterPositions,
          company: this.filterCompanies,
          department: this.filterDepartments,
          division: this.filterDivisions,
          subdivision: this.filterSubdivisions,
          level05: this.filterLevels05,
          periodicity: this.filterPeriodicity,
          status: this.filterStatuses,
          sort_column: this.sortColumn,
          sort_direction: this.sortDirection,
        };

        await this.getFilterOptions(data);
        let resp = await api.getMatrixActivitiesList(data);
        this.employees = resp.data.data;
        this.pages = resp.data.links;

        await this.filterActivities();
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },
    changePage(val) {
      if(val === '...') {
        return;
      }

      if(val === 'pagination.previous') {
        val = Number(this.activePage) - 1;
      }

      if(val === 'pagination.next') {
        val = Number(this.activePage) + 1;
      }

      val = Number(val);

      this.activePage = val;
      if (val === 1) {
        val = null;
      }
      this.getActivities();
    },
    async onDropdownUpdate(e, property, filterOptionsName) {
      this.lastUsedFilterOptions = filterOptionsName;
      this[property] = e;
      if (this.activePage > 1) await this.changePage(1);
      await this.filterActivities();
    },
    searchActivities: debounce(function () {
      if (this.activePage > 1) this.changePage(1);
      this.filterActivities();
    }, 700),
    async sortChange(sortingColumn) {
      if (sortingColumn !== this.sortColumn) {
        this.sortColumn = sortingColumn;
        this.sortDirection = '';
      }

      if (this.sortDirection === '') {
        this.sortDirection = 'asc';
      } else if (this.sortDirection === 'asc') {
        this.sortDirection = 'desc';
      } else if (this.sortDirection === 'desc') {
        this.sortDirection = '';
        this.sortColumn = null;
      }

      await this.filterActivities();
    },
    getSortingIcon(sortingColumn) {
      if (sortingColumn !== this.sortColumn || this.sortDirection === '') {
        return '/images/sort.svg';
      } else if (this.sortDirection === 'asc') {
        return '/images/sort_active_asc.svg';
      } else if (this.sortDirection === 'desc') {
        return '/images/sort_active_desc.svg';
      }
    },
    hideCM() {
      this.contextMenu.isVisible = false;
    },
    async changStatus(status) {
      await api.changeMatrixActivityStatus(this.contextMenu.item.id, status);
      this.contextMenu.isVisible = false;
      await this.getActivities();
    },
    editMatrix() {
      this.$bvModal.show('matrix-edit-modal');
    },
    async deleteMatrixItem() {
      const matrixId = this.contextMenu.item.id;
      try {
        await api.deleteMatrixActivity(matrixId);
      } catch (e) {
        console.error(e);
      }
      this.contextMenu.isVisible = false;
      await this.getActivities();
    },
    openAssignmentsModal() {
      this.$bvModal.show('assignment-view-modal');
    },
    createMatrix() {
      this.$bvModal.show('matrix-create-modal');
    },
    importMatrix() {
      const input = document.createElement('input');
      input.type = 'file';
      input.onchange = e => this.getExcelFile(e);
      input.click();
    },
    async exportMatrix() {
      await api.exportMatrix().then(async response => {
        const blob = await response.data
        const objectUrl = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.setAttribute('href', objectUrl)
        link.setAttribute('download', 'matrix.xlsx')
        link.click()
      });
    },
    async getExcelFile(event) {
      const file = event.target.files[0];
      const data = new FormData();
      data.append('file', file)

      const resp = await api.importMatrixFromExcel(data);
      if (!resp.data.success) {
        const message = this.$t('admin.matrix_import_error');
        this.$toasts.error(message, {
          duration: 700000,
        });
        return;
      }
      await this.getActivities();
    },
  },
  async mounted() {
    this.reportsButton.onclick = () => this.isReportsOpened = !this.isReportsOpened;
    this.reportsLoadingButton.onclick = () => this.isReportsOpened = !this.isReportsOpened;

    await this.getActivities();
  },
}
</script>
